import { BRAND, DISCLAIMER, NAV_LINKS } from "@/components/site/data";

export default function Footer() {
  return (
    <footer className="bg-base border-t border-white/10 pt-16 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-5">
            <p className="font-serif text-3xl text-[#f5f5f0]">{BRAND.name}</p>
            <p className="overline mt-2">{BRAND.arn}</p>
            <p className="text-zinc-500 mt-5 max-w-sm leading-relaxed">
              {BRAND.amfi}. Helping you invest with clarity, discipline and long-term conviction.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="overline mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-zinc-400 hover:text-[#c6a87c] transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Reach Me</p>
            <ul className="space-y-3 text-zinc-400">
              {BRAND.phones.map((p) => (
                <li key={p}><a href={`tel:+91${p}`} className="hover:text-[#c6a87c] transition-colors">+91 {p}</a></li>
              ))}
              <li><a href={`mailto:${BRAND.email}`} className="hover:text-[#c6a87c] transition-colors break-all">{BRAND.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row gap-6 md:items-center md:justify-between">
          <p className="text-xs text-zinc-600 max-w-2xl leading-relaxed">{DISCLAIMER}</p>
          <p className="text-xs text-zinc-600 shrink-0">
            &copy; {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
